import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { map, Observable } from 'rxjs';

import { Cgu } from '@models/cgu.model';
import { CGU_DOCUMENT_TYPE, CguApiService } from '@services/api/cgu-api.service';

@Injectable({
  providedIn: 'root'
})
export class CGUGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly cguApiService = inject(CguApiService);

  canActivate(): Observable<boolean | UrlTree> {
    return this.isCGUAccepted();
  }

  private isCGUAccepted(): Observable<boolean | UrlTree> {
    return this.cguApiService.unsignedDocumentAgreements().pipe(
      map((unsignedDocuments: Cgu[]) => {
        if (unsignedDocuments.some((document: Cgu) => document.type === CGU_DOCUMENT_TYPE)) {
          return this.router.createUrlTree(['cgu']);
        }

        return true;
      })
    );
  }
}
